import * as _ from 'lodash'
import moment from 'moment'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import 'react-table/react-table.css'
import SSPList from '../../containers/SSPList'

import { LLFormat } from '../../services/ValidationRules'
import { MultiSelectFilter, onDatePickerFilterTimeStampOutput, onTextFilter } from './CommonTableDataFilter'
import { CertificateCell, CheckboxCell } from './TableComponents'
import HeaderSelectCell from './HeaderSelectCell'

import { CHECKBOX_COLUMN_WIDTH } from '../../constants/boards'

export const chargersListDefaultSorting = { id: 'uuid', desc: false }
export const deviceStates = [
  { name: 'BUILT', label: 'Built' },
  { name: 'IN_PROGRESS', label: 'In Progress' },
  { name: 'ERROR', label: 'Error' },
  { name: 'PENDING', label: 'Pending' },
  { name: 'ACTIVE', label: 'Active' },
  { name: 'INACTIVE', label: 'Inactive' },
  { name: 'NEW', label: 'New' },
  { name: 'AUTO_TRANSFERRED', label: 'Transferring' },
  { name: 'TRANSFERRED', label: 'Transferred' }
]

export const DEVICE_STATE_ACCESSOR = 'device_state'

class BoardsList extends Component {
  render () {
    const columns = [
      {
        id: 'checkbox',
        accessor: '',
        resizable: false,
        width: CHECKBOX_COLUMN_WIDTH,
        Header: () => (
          <HeaderSelectCell
            selectAll={this.props.selectAll}
            effectiveSelectedCount={this.props.effectiveSelectedCount !== undefined
              ? this.props.effectiveSelectedCount
              : (this.props.activeChargerIds ? this.props.activeChargerIds.length : 0)}
            excludedDataIds={this.props.excludedDataIds}
            deselectAllRows={this.props.deselectAllRows}
            toggleSelectAll={this.props.toggleSelectAll}
            onToggleCurrentPage={this.props.toggleCurrentPageSelectAll}
          />
        ),
        Cell: ({ original }) => (
          <div>
            <CheckboxCell
              id={original.id}
              activeChargerIds={this.props.activeChargerIds}
              excludedDataIds={this.props.excludedDataIds}
              onRowSelected={this.props.onRowSelected}
              selectAll={this.props.selectAll}
            />
          </div>
        ),
        filterable: false,
        sortable: false,
        minWidth: 40
      }, {
        Header: 'Created Date',
        accessor: 'created_date',
        Filter: onDatePickerFilterTimeStampOutput,
        minWidth: 200,
        Cell: ({ value }) => <div>{value ? moment.utc(value).format(LLFormat) : ''}</div>
      }, {
        Header: 'Flashed Date',
        accessor: 'flashed_date',
        Filter: onDatePickerFilterTimeStampOutput,
        minWidth: 200,
        Cell: ({ value }) => <div>{value ? moment.utc(value).format(LLFormat) : ''}</div>
      }, {
        Header: 'Chip ID',
        accessor: 'uuid',
        minWidth: 200,
        Filter: onTextFilter,
        Cell: ({ original, value: uuid }) => <div><Link to={`/charger/${original.id}`}>{uuid}</Link></div>
      }, {
        Header: 'Customer ID',
        accessor: 'customer_id',
        minWidth: 100,
        Filter: onTextFilter
      }, {
        Header: 'Firmware Version',
        accessor: 'firmware_version', // 'fw_version',
        minWidth: 200,
        Filter: onTextFilter
      }, {
        Header: 'Properties',
        accessor: 'properties',
        minWidth: 200,
        Filter: onTextFilter,
        Cell: ({ original, value }) => {
          const propertyCount = Object.keys(value).length
          const inlineProperties = Object.keys(value).map(key => key + ': ' + value[key]).join('\n')

          return <Link
            to={`/charger/${original.id}`}
            title={inlineProperties}>{propertyCount} properties</Link>
        }
      }, {
        Header: 'State',
        accessor: DEVICE_STATE_ACCESSOR,
        id: 'device_states',
        minWidth: 200,
        Cell: ({ value }) => <div>{_.get(deviceStates.find(state => state.name === value), 'label')}</div>,
        Filter: ({ filter, onChange }) => (
          <MultiSelectFilter
            options={_.sortBy(deviceStates, 'label')}
            onChange={onChange}
            value={filter ? filter.value : []}
          />
        )
      }, {
        Header: 'Certificates',
        accessor: 'provisioning_certificate',
        minWidth: 200,
        Cell: ({ original }) => (
          <div>
            <CertificateCell
              value={original} />
          </div>),
        filterable: false,
        sortable: false
      }
    ]

    return (
      <SSPList
        onGetDataAction={this.props.getData}
        defaultPageSize={20}
        defaultSorted={chargersListDefaultSorting}
        id="chargersList"
        columns={columns}
        clearFilterOnInit
      />
    )
  }
}

export default (BoardsList)
